import React from 'react';
import { Spinner } from '@deere/ux.uxframe-react';

const BodyContentLoader = () => (
  <div className="d-flex w-100 justify-content-center align-items-center spinner-center">
    <Spinner accessibilityLabel="Loading" className="uxf-spinner-border-lg" animation="border" />
  </div>
);
export default BodyContentLoader;
